<template>
    <div >
        
        <navbar-tournoi
            :club="club"
            :tournoi="tournoi"
            :parties="parties"
            :role="role"
            display="resultat"
            @nav="setNav"
            @back="$emit('back')"
            v-if="showMenu"
        />
         
        <div class="g_menuDesktop sheaderClassement"  >
            <div class="title is-4" style="float:left">
                <s-l id="resultat_title">Classement </s-l>
                <span v-show="finish || tournoi.state=='FINISH'">
                    <s-l id="resultat_final"> FINAL</s-l>
                </span>
                <span v-show="!finish && tournoi.state!='FINISH'">
                    <s-l id="resultat_provisoire"> PROVISOIRE</s-l>
                    
                </span>
                
                <div style="width:100%"  v-if="tournoi.state=='FINISH'">
                <s-button :icon="!displayPodium ? 'window-maximize' : 'window-minimize'" 
                    :label="displayPodium ? 'Afficher les résultats' : 'Afficher le podium'" 
                    @onclick="displayPodium=!displayPodium" 
                    theme="is-small is-primary"
                   />&nbsp;&nbsp;
                    <div style="float:right"  v-if="role=='admin' || role=='owner'">
                        <s-switch id="editer" 
                            label-enable-text="Editer"
                            label-disable-text="Lecture"
                            :defaultState="edit"
                            @change="edit=!edit;captainIdSelected=null"
                        />
                    </div>
                </div>
                
                <div >
                    <s-button icon="check" 
                                label="Clôturer le tournoi"
                                theme="is-success" @onclick="modalCloturer=true" 
                                v-show="tournoi.state!='FINISH'"
                                :role="role"
                                v-if="finish"
                                />
                     <s-button icon="trash" 
                                :label="'Supprimer la partie '+this.parties.length"
                                theme="is-danger" @onclick="modalDeletePartie=true" 
                                v-show="tournoi.state!='FINISH'"
                                :role="role"
                                v-if="!finish && this.parties.length>0"
                                />
                                &nbsp; 
                </div>
               
            </div>
            <div style="float:right" v-if="!$isAnonyme()" >
                <s-button icon="edit" label="Editer le classement" 
                    @onclick="$emit('nav', 'resultatEdit')"
                    theme="is-warning"
                    :role="role"
                    v-if="tournoi.clotured"
                />
                
                <s-button icon="file-pdf" theme="is-info is-normal" label="Exporter en pdf" 
                    @onclick="generateReport()" v-if="classementPagination.length!=0"/>
                &nbsp;   
                <s-button theme="is-info is-normal" 
                        label="Exporter en excel" icon="file-excel"
                        @onclick="exportEXCEL()"
                />&nbsp;
              
                
                <vue-html2pdf
                        :show-layout="false"
                        :float-layout="true"
                        :enable-download="true"
                        :preview-modal="false"
                        :paginate-elements-by-height="200"
                        filename="hee hee"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        pdf-format="a4"
                        pdf-orientation="portrait"
                        pdf-content-width="800px"
                        :html-to-pdf-options="options"
                        @startPagination="startPagination"
                        ref="html2Pdf"
                        v-if="classementPagination.length!=0 && club"
                    >
                        <pdf-resultat 
                            v-if="classementPagination.length!=0" 
                            :tournoi="tournoi" slot="pdf-content" 
                            :club="club" 
                            :classement="classementPagination" :nbParties="nbParties"
                            :mode="0"
                            />
                    </vue-html2pdf>
                <s-confirm
                    :open="modalReactiver"
                    title="Réactiver le tournoi"
                    @yes="reactiver()"
                    @no="modalReactiver=false"
                    >
                    <s-l id="resultat_reactiver">
                        Etes vous sûr de vouloir réactiver le tournoi ?
                    </s-l>
                </s-confirm>
                
            </div>
            <div style="float:right">
                <s-button icon="undo-alt" 
                    label="Réactiver le tournoi" 
                    @onclick="modalReactiver=!modalReactiver" 
                    v-show="tournoi.state=='FINISH'"
                    theme="is-warning"
                     v-if="!tournoi.clotured"
                     :role="role"/>
               &nbsp;&nbsp;
            <s-button icon="play"   
                            :label="tournoi.state=='FINISH' ? 'Revoir les parties' : 'Reprendre'"
                            theme="is-success" @onclick="$emit('viewGame')" 
                            
                />&nbsp;&nbsp;
                
                
            </div>
            
            
        </div>
        <div class="g_menuMobile">
            <table class="g_menuFooterMin">
                <tr>
                    <td colspan="4" class="g_headerFooter">Classement
                        <span v-show="finish || tournoi.state=='FINISH'">
                            FINAL
                        </span>
                        <span v-show="!finish && tournoi.state!='FINISH'">
                           PROVISOIRE
                        </span>
                      
                        
                    </td>
                </tr>
                <tr>
                    <td  >
                        <div v-if="tournoi.state=='FINISH'">
                            <s-button icon="undo" 
                                label="retour"
                                theme="is-warning"
                                @onclick="$emit('back')"
                                mode="V"
                            />
                        </div>
                        <div v-if="finish && tournoi.state!='FINISH'" >
                        
                            <s-button icon="check" 
                                label="Cloturer"
                                theme="is-success" @onclick="modalCloturer=true" 
                                :role="role"
                                mode="V"
                                id="Clôturer le tournoi"
                            />
                        </div>
                       
                    </td>
                    <td>
                       <s-button theme="is-light" 
                                :label="!podium ? 'Classement' :'Podium'"
                                :icon="!podium ? 'trophy' : 'list-ol'" @onclick="podium=!podium" 
                                v-show="tournoi.state=='FINISH'"
                                mode="V"
                                
                        />
                        
                    </td>
                    <td>
                        <s-button icon="download" theme="is-info is-normal" label="Exporter" 
                            @onclick="modalExporter = true" mode="V" 
                            v-if="classementPagination.length!=0"/>
                    </td>
                    <td>
                        <s-button icon="play" 
                                :label="tournoi.state=='FINISH' ? 'Revoir les parties' : 'Reprendre'"
                                theme="is-success" @onclick="$emit('viewGame')" 
                                
                                mode="V"
                        />
                    </td>
                    <td>
                      
                        <s-button :icon="!edit ? 'edit' : 'ban'" 
                                label="Editer"
                                :theme="edit ? 'is-danger' : 'is-success'" 
                                @onclick="edit=!edit;captainIdSelected=null" 
                                v-show="tournoi.state=='FINISH' "
                                :role="role"
                                mode="V"
                        />
                    </td>
                    <td>
                         <s-button icon="refresh" 
                            label="Réactiver" 
                            @onclick="modalReactiver=!modalReactiver" 
                            v-show="tournoi.state=='FINISH'"
                            theme="is-warning"
                            v-if="!tournoi.clotured"
                            mode="V"
                            :role="role"/>
                    </td>
                </tr>
            </table>
        </div>
        
        
        
        <div  class="podiumDiv" v-if="tournoi.state=='FINISH' && displayPodium">
            <div :class="finish || tournoi.state=='FINISH' ? 'wrapper' : ''">
                
                <div  v-if="(finish || tournoi.state=='FINISH') && tournoi">
                <div v-for="i in 300" :class="'confetti-'+i" v-if="tournoi.state=='FINISH'">
                 </div>   
                 </div>
            <div :class="!podium ? 'podiumTITLE podiumOff' : 'podiumTITLE'" v-if="classement.length>0">
                <div class="prems">
                        <div class="nomprenom" v-if="tournoi.options.mode!='FORME'">
                            {{classement[0].numero+1}} 
                            <span v-if="classement[0].captain==''"><i>Invité</i></span>
                            <span v-if="classement[0].captain!=''">{{classement[0].captain}}</span>
                        </div>
                        <div class="nomprenom" v-if="tournoi.options.mode=='FORME'">
                            {{classement[0].numero+1}} 
                            {{classement[0].nameEquipe}}
                            <div>
                            <span v-if="classement[0].captain==''"><i>Invité</i></span>
                            <span v-if="classement[0].captain!=''">{{classement[0].captain}}</span>
                            </div>
                        </div>                      
                        <div v-if="classement[0].coequipier1!=''">
                            <div class="nomprenom" >
                                {{classement[0].coequipier1}}
                            </div>
                        </div>
                        <div v-if="classement[0].coequipier2!=''">
                            <div class="nomprenom">
                                {{classement[0].coequipier2}}
                            </div>
                        </div>
                </div>
                <div style="width:360px">
                    <div class="deux">
                           <div class="nomprenom" >
                        {{classement[1].numero+1}} {{classement[1].captain}}
                        </div>
                        
                        <div v-if="classement[1].coequipier1!=''">
                            <div class="nomprenom" >
                                {{classement[1].coequipier1}}
                            </div>
                        </div>
                        <div v-if="classement[1].coequipier2!=''">
                            <div class="nomprenom">
                                {{classement[1].coequipier2}}
                            </div>
                        </div>
                    </div>
                    <div class="trois">
                            <div class="nomprenom" >
                        {{classement[2].numero+1}}  {{classement[2].captain}}
                        </div>
                        
                        <div v-if="classement[2].coequipier1!=''">
                            <div class="nomprenom" >
                                {{classement[2].coequipier1}}
                            </div>
                        </div>
                        <div v-if="classement[2].coequipier2!=''">
                            <div class="nomprenom">
                                {{classement[2].coequipier2}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="podium">
                    &nbsp;
                </div>
            
            </div>
            </div>
        </div>
        
         <s-modal
            title="Exporter"
            :open="modalExporter"
            @close="modalExporter=false"
            :close="true"
        >
            Exporter le résultat :
             <div>
                <s-button icon="file-pdf" theme="is-info is-normal" label="PDF" 
                    @onclick="generateReport()" mode="V" 
                    v-if="classementPagination.length!=0"/>
            </div>
            <div>
                <s-button icon="file-excel" theme="is-info is-normal" label="EXCEL" 
                    @onclick="exportEXCEL()" mode="V" 
                    v-if="classementPagination.length!=0"/>
            </div>
         </s-modal>
         
         
         <s-confirm
            title="Clôturer le tournoi"
            @yes="cloturer"
            @no="modalCloturer=false"
            :open="modalCloturer">
           
            <div class="notification is-info">
                <s-l id="resultat_explain">Une fois le tournoi clouré, il sera considéré comme "Archivés" <br/>
                Vous pouvez le retrouver dans la liste des tournois de votre club pour visualiser les résultats en cliquant sur "Archivés"<br/>
                </s-l>
            </div>
            <div class="notification is-danger" v-if="tournoi.length!=0">
                Il sera archivé pendant une période de 
                <span v-show="tournoi.options.mode == 'FREE'">
                    24 heures
                </span>
                <span v-show="tournoi.options.mode != 'FREE'">
                    2 ans
                </span>
                <br/>
                Au delà il sera définitivement supprimé...
            </div><hr/>
            <span class="title is-3"> <s-l id="resultat_confirm">Souhaitez vous clore ce tournoi ?</s-l></span>
         </s-confirm>
         <br/><br/>
         <div class="notification is-warning" v-show="classement.length==0">
            <s-l id="resultat_alert">Aucun classement n'est possible pour le moment </s-l>
         </div>
         <div class="array_classement">
        <div class='headerTableClassement' v-if="!displayPodium">
            <table class="tableClassement g_desktopOn"  v-if="!displayPodium" >
                <tr>
                    <th style="width: 30px">
                        
                    </th>
                      <th style="width: 200px">
                        <s-l id="resultat_array_nomprenom">Nom Prénom</s-l>
                    </th>
                    <th >
                         <s-l id="resultat_array_gagnes">Gagnés</s-l>
                        
                    </th>
                  
                   
                   
                    <th  v-for="(index) in nbParties" >
                         <s-l id="resultat_array_partie" :v="index">Partie %v</s-l> 
                    </th>
                    <th >
                         <s-l id="resultat_array_goal">Goal Average</s-l>
                    </th>
                    
                </tr>
            </table>   
        </div>
        <div class="divTableClass" v-if="!displayPodium">
            
        <table class="tableClassement" v-show="classement.length!=0" v-if="tournoi">
            <thead class="tableClassement g_mobileOn"  v-if="!displayPodium">
                
                <tr>
                    <th style="width: 30px">
                        
                    </th>
                      <th style="width: 200px">
                        <s-l id="resultat_array_nomprenom">Nom Prénom</s-l>
                    </th>
                    <th >
                         <s-l id="resultat_array_gagnes">Gagnés</s-l>
                        
                    </th>
                  
                   
                   
                    <th  v-for="(index) in nbParties" >
                         <s-l id="resultat_array_partie" :v="index">Partie %v</s-l> 
                    </th>
                    <th >
                        <div style="width:100%;margin-left:auto;margin-right:auto">
                         Goal Average
                        </div>
                    </th>
                    
                </tr>
            
            </thead>
            <tbody>
            <tr v-for="(classement_item, indexClassement) in classement" v-if="classement_item"
            :class="captainIdSelected == classement_item.captainId ? 'ligneSelected' : ''"
            >
                <td  style="width: 30px" class="nomprenom">
                     <div class="indexClassement" >
                         <b>{{classement_item.classement}}</b>
                           &nbsp;&nbsp;&nbsp;
                     </div>
                </td >
                <td class="nomprenom">
                    <div style="margin-left: 10px;display:inline-block;">
                    <div v-if="tournoi.options.mode!='FORME'">
                        <span v-if="!tournoi.clotured">{{classement_item.numero+1}} - </span>
                        <span v-if="classement_item.captain==''"><i>Invité</i></span>
                        <span v-if="classement_item.captain!=''">{{classement_item.captain}}</span>
                    </div>
                    <div v-if="tournoi.options.mode=='FORME'">                        
                        <span v-if="!tournoi.clotured">{{classement_item.numero+1}} - </span>
                        {{classement_item.nameEquipe}}
                        <div class="coequipier">
                            <span v-if="classement_item.captain==''"><i>Invité</i></span>
                            <span v-if="classement_item.captain!=''">{{classement_item.captain}}</span>
                        </div>
                   
                        <div v-if="classement_item.coequipier1!=''" class="coequipier">
                            <div  >
                                {{classement_item.coequipier1}}
                            </div>
                        </div>
                        <div v-if="classement_item.coequipier2!=''"  class="coequipier">
                            <div >
                                {{classement_item.coequipier2}}
                            </div>
                        </div>
                    </div>
                    </div>
                </td>
                <td class="nomprenom">
                   {{classement_item.nbPartieGagne}}
                </td>
                <td  v-for="(index) in nbParties" class="nomprenom" > 
                    <span v-show="!edit">
                    {{classement_item.partieScore[index-1]}}
                    </span>
                   
                    <s-button afterIcon="edit" 
                        :label="classement_item.partieScore[index-1]" 
                        :theme="(captainIdSelected == classement_item.captainId && indexSelected==index-1) ? 'is-small is-warning' : 'is-small'" 
                        @onclick="openModalEdit(classement_item, index-1, indexClassement)" 
                        v-show="edit"/>
                </td>
                <td class="nomprenom">
                    {{classement_item.diff}}
                </td>
               
                
            </tr>
            </tbody>
            
            
        </table>
        </div>
         </div>
        <div style="height:100px">
            &nbsp;
        </div>
        <s-modal
            
            :open="modalEdit"
            :close="true"
            @close="modalEdit=false"
            :title="classementSelected != null ? classementSelected.captain : ''"
        >
            <div v-if="classementSelected!=null">
            <b>Editer le goal average de ce joueur pour la partie {{indexSelected+1}} :</b><br/><br/>
            <div style="text-align:center">
                <s-button @onclick="winSelected=true" 
                    :theme="winSelected ? 'is-success' : ''"
                    label="Gagné"
                /> &nbsp;
                <s-button @onclick="winSelected=false" 
                    :theme="!winSelected ? 'is-danger' : ''"
                    label="Perdu"
                />
            </div>
           
            <br/>
           <div v-for="score in tabScore" class="score">
                <s-button :label="score" 
                :icon="Math.abs(classementSelected.partieScore[indexSelected])==Math.abs(score) ? 'check' : ''"
                :theme="(winSelected ? 'is-success ' : 'is-danger ') + 'is-medium'" @onclick="editClassement(score)"/>
            </div>
            <div style="margin-top: 10px;text-align:right">
            Goal Average Maximum : <s-input theme="is-info is-small" width="100px" v-model="maxPoint" type="number" /><br/>
            </div>
            </div>
        </s-modal>
        <s-confirm
            :open="modalDeletePartie"
            @yes = "deletePartie()"
            @no="modalDeletePartie=false"
        >
            <s-l id="resultat_supParie" :v="parties.length">Confirmez vous la suppression de la partie %v ?
            </s-l>
        </s-confirm>
        </div>
  
    
</template>
<style lang="scss" scoped>
    .ligneSelected {
        background-color: #e4dbc0;
    }
    .score {
        display: inline-block;
        margin: 8px;
    }
    .editScore {
         background-color: rgb(229, 216, 147);
         border-style: outset;
    }
    .editScore:hover {
        background-color: rgb(161, 187, 101);
        cursor: pointer;
    }
     .sheaderClassement {
         position: fixed;
         z-index:3;
         top: 50px;
         padding-top: 10px;
         padding-left: 10px;
         padding-right: 10px;
         background-color: white;
         width: 100%;
         height: 135px;
     }
     .coequipier {
        font-size: 12px;
        font-style: italic;
        font-weight: normal;
     }
      @media screen and (max-width: 420px) and (min-height: 600px) {
         .array_classement {
            width: 100%;
            margin-top: 10px;
            overflow: auto;
            max-height: 500px;
        }
     }
       @media screen and (max-width: 420px) and (min-height: 700px) {
          .array_classement {
            width: 100%;
            margin-top: 10px;
            overflow: auto;
            max-height: 550px;
        }
      }

     @media screen and (max-width: 420px) {
         .podiumOff {
             visibility: hidden;
             display: none;
         }
        
        .headerTableClassement { 
            margin-top: 10px;
            
        }
        
        div.divTableClass {
            margin-top: 0px;
            width:100%;
        }
     }
     @media screen and (min-width: 420px) {
         .podiumOff {
             
         }
         .array_classement {
            display: flex;
            height: 100%;
            margin-top: 140px;
        }
         
        .headerTableClassement {
            position: fixed;
            z-index:3;
            top: 150px;
            width: 100%;
            box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
        }
        div.divTableClass {
            margin-top: 0px;
            width:100%;
        }
     }
    
    .numero {
        width: 10px;
    }
    
    .wrapper {
    position: relative;
    height: 300px;
    }

    [class|="confetti"] {
    position: fixed;
    }

    $colors: (#d13447, #ffbf00, #263672);

    @for $i from 0 through 150 {
    $w: random(8);
    $l: random(100);
    .confetti-#{$i} {
        width: #{$w}px;
        height: #{$w*1}px;
        background-color: nth($colors, random(3));
        top: -10%;
        left: unquote($l+"%");
        opacity: random() + 0.5;
        transform: rotate(#{random()*360}deg);
        border-radius: 20px;
        animation: drop-#{$i} unquote(4+random()+"s") unquote(random()+"s") infinite;
    }

    @keyframes drop-#{$i} {
        100% {
        top: 110%;
        left: unquote($l+random(15)+"%");
        }
    }
    }
</style>
<style  scoped>
    .nomprenom {
        font-size: 15px;
        color: black;
        vertical-align: middle;
    }
    .headerClassement {
        position: fixed;
        width: 100%;
    }
    .podiumDiv {
        text-align:center;
        padding-top:200px;
        border-radius: 30px;
        margin-left: auto;
        margin-right: auto;
    }
    @media screen and (max-width: 420px) {
        .podiumDiv {
            width: 100%;
        }
    }
    @media screen and (min-width: 420px) {
        .podiumDiv {
            width: 50%;
        }
    }
    .podiumTITLE {
        height: 260px;
        font-size: 12px;
        vertical-align: bottom;
        text-align: center;
        margin-left:auto;
        margin-right: auto;
        width: 375px;
         background-image: url("../../assets/podium.png");
        background-repeat: no-repeat;
        background-size: contain; 
        background-position: bottom;
    }
    .prems {
        height: 20px;
        font-size: 14px;
        font-weight: bold;
    }
    .deux {
       float: left;
       font-size: 13px;
       padding-top: 45px;
    }
    .trois {
        float: right;
        font-size: 12px;
        padding-top: 60px;
    }
    
    .header {
        overflow-y: scroll;
        
    }
    .header div {
        display: inline-block;
        border: thin solid black;
        background-color: rgb(39, 121, 177);
        color: white;
        text-align: center;
        font-size: 18px;
        font-weight: bolder;
    }
    .classement div {
        display: inline-block;
        border: thin solid black;
        font-size: 14px;
        height: 40px;
        padding-top: 3px;
    }
    .nom {
      
        text-align: left;
        
    }
    .medaille {
       
    }
    .nb {
        
         text-align: center;
    }
    .score {
        width: 17%;
        font-weight: bold;
        text-align: center;
    }
    .indexClassement {
        display: inline-block;
        margin-right: 5px;
        padding-left: 5px;
        height: 100%;
        width: 30px;
        vertical-align: middle;
    }
    
    .tableClassement td,
    th {
        border: 1px solid #000;
        width: 100px;
        text-align: center;
    }
    .tableClassement th {
        background-color:var(--bluebg);
        text-align: center;
        color: white;

    }

    table.tableClassement {
        table-layout: fixed;
        width:100%;
        color: black;
        font-weight: bolder;
    }
    @media screen and (max-width: 420px) {
        .tableClassement td:first-child, th:first-child {
            position:sticky;
            left:0;
            z-index:1;
            width: 200px;
            background-color:var(--bluebg);
            color: white;
            font-size: 14px;
            text-align: left;
            height: 100%;
            
        }
        .tableClassement td:nth-child(2),  th:nth-child(2) {
            position:sticky;
            left:0;
            z-index:2;
            width: 200px;
            background-color:var(--bluebg);
            color: white;
            font-size: 14px;
            text-align: left;
            height: 100%;
        }
    }
    @media screen and (min-width: 420px) {
        .tableClassement td:first-child, th:first-child {
            position:sticky;
            left:0;
            z-index:1;
            width: 150px;
            background-color:var(--bluebg);
            color: white;
            text-align: left;
            height: 100%;
        }
        .tableClassement td:nth-child(2),  th:nth-child(2) {
            position:sticky;
            left:0;
            z-index:2;
            width: 200px;
            background-color:var(--bluebg);
            color: white;
            font-size: 14px;
            text-align: left;
            height: 100%;
        }
        
    }
    
    
    .tableClassement thead tr th {
    position:sticky;
    top:0;
    z-index: 2;
    text-align: center;
    }
    .tableClassement th:first-child {z-index:4;background-color:var(--bluebg);}
    .tableClassement th:nth-child(2) {z-index:4;background-color:var(--bluebg);}

</style>
<script>
import tournoi_fct from "@/firebase/tournoi"
import firebase_api from "@/firebase/firebase_api"
import navbarTournoi from "@/views/tournoi/navbar.vue"
import PdfResultat from "@/views/tournoi/export/pdfresultat.vue"

import XLSX from 'xlsx'
import VueHtml2pdf from 'vue-html2pdf';
import SModal from '../../components/SModal.vue'
export default {
    props: ["club","tournoi", "role", "menu"],
    components: {
        navbarTournoi,
        PdfResultat,
        VueHtml2pdf
    },
 
   data() {
        return {
            options: {
                marge: [10, 10],
                filename: this.filename(),
                html2canvas: {
                scale: window.devicePixelRatio,
                useCORS: true,
                proxy: 'https://firebasestorage.googleapis.com'
                },
            },
            classement: [],
            classementPagination: [],
            parties: [],
            finish: true,
            modalCloturer: false,
            podium: true,
            displayPodium: false,
            modalReactiver: false,
            nbPartiesCalcule: 0,
            edit: false,
            modalEdit: false,
            classementSelected: null,
            indexSelected: null,
            maxPoint: 13,
            winSelected: null,
            indexClassementSelected: null,
            captainIdSelected: null,
            modalDeletePartie: false,
            modalExporter: false
        }
    },
    methods: {
        deletePartie() {
            var idPartie = "P" + (this.parties.length-1);
            firebase_api.api.getDb().collection("club").doc(this.club.id)
                        .collection("tournois")
                        .doc(this.tournoi.id)
                        .collection("parties")
                        .doc(idPartie).delete().then(()=>{
                            this.modalDeletePartie=false;
                            this.finish = true;
                            this.refresh();
                            this.$emit("changeIndexPartie",0);
                        })
        },
        editClassement(score) {
            
            var scoreSave = score;

            if (scoreSave<0 && this.winSelected)
                scoreSave = -scoreSave;
            if (scoreSave>0 && !this.winSelected)
                scoreSave = -scoreSave;
            
            this.classement[this.indexClassementSelected].partieScore[this.indexSelected] = scoreSave;
            var diff = 0;
            var win = 0;
            var lose = 0;
            this.classement[this.indexClassementSelected].partieScore.forEach(item=>{
                if (item > 0)
                    win++;
                else
                    lose++;
                diff += parseInt(item);
            })
            this.classement[this.indexClassementSelected].nbPartieGagne = win;
            this.classement[this.indexClassementSelected].score = win;
            this.classement[this.indexClassementSelected].nbPartiePerdu = lose;
            this.classement[this.indexClassementSelected].diff = diff;
            this.modalEdit = false;
            this.classement.sort((a,b)=> {
                return b.score - a.score || b.diff - a.diff;
            });
            var classementModif = 1;
            var classementEgalite = true;
            this.classement.forEach((classementItem, indexClassement)=>{
                if (!classementEgalite)
                    classementModif = indexClassement+1;
                this.classement[indexClassement].classement = classementModif;
                if (indexClassement < this.classement.length-1) {
                    var currentItem = this.classement[indexClassement];
                    var currentItemNext = this.classement[indexClassement+1];
                    
                    if (currentItem.score != currentItemNext.score) {
                        classementModif ++;
                        classementEgalite = false;
                    }
                        
                    else if (currentItem.diff != currentItemNext.diff) {
                        classementModif ++;  
                            classementEgalite = false;    
                    }
                    else
                            classementEgalite = true;
                }
                
            })
            tournoi_fct.object.setFinish(this.club, this.tournoi, this.classement, ()=>{
                this.modalCloturer = false;
                this.refresh();
            })
        },
        openModalEdit(classement_item, index, indexClassementSelected) {
            this.modalEdit=true;   
            this.classementSelected = classement_item;
            this.indexSelected = index;
            this.winSelected = this.classementSelected.partieScore[index] > -1;
            this.indexClassementSelected = indexClassementSelected;
            this.captainIdSelected = classement_item.captainId;
        },
        startPagination() {
           
        },
        finishDownload() {

        },
        
         generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
        exportEXCEL() {
            var prepareClassement = [];
            
            this.classement.forEach((classement, indexClassement) =>{
                if (classement!=null) {
                    var ligne = {};
                    if (typeof(classement.classement)=="undefined")
                        ligne.CLASSEMENT = indexClassement + 1;
                    else
                        ligne.CLASSEMENT = classement.classement;
                    ligne.NUMERO = parseInt(classement.numero) + 1;
                    ligne.NOM_PRENOM = classement.captain;
                    ligne.GAGNES = classement.nbPartieGagne;
                    classement.partieScore.forEach((score, indexScore)=>{
                        ligne["PARTIE"+(indexScore+1)] = score;
                    })
                    ligne.GOALAVERAGE = classement.diff;
                    prepareClassement.push(ligne);
                }
            })
            var classements = XLSX.utils.json_to_sheet(prepareClassement) 
            // A workbook is the name given to an Excel file
            var wb = XLSX.utils.book_new() // make Workbook of Excel

            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            XLSX.utils.book_append_sheet(wb, classements, 'classements du concours') // sheetAName is name of Worksheet
            var nameFile = this.filename() + ".xlsx";
            // export Excel file
            XLSX.writeFile(wb, nameFile) // name of the file is 'book.xlsx'
        },
        setNav(nav) {
            
            this.$emit("nav",nav)
        },
        cloturer() {
          
            tournoi_fct.object.setFinish(this.club, this.tournoi, this.classement, ()=>{
                this.modalCloturer = false;
                this.refresh();
            })
        },
        reactiver() {
            delete this.tournoi.classement;
            this.tournoi.state = 'INPROGRESS';
            tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                this.modalReactiver=false;
            })
        },
        filename() {
                var filename = this.club.id;
                var today = new Date(this.tournoi.date);
                return filename + " RESULTAT " + today.getFullYear() + today.getMonth() + today.getDate();
            },
        refresh() {
                this.parties = [];
                if (this.tournoi.length!=0) {
                    
                if (this.tournoi.state=='FINISH') {
                    if (typeof(this.tournoi.classement)!="undefined")
                        this.classement = this.tournoi.classement
                    var indexPagination = 0;
                    var compteur=0;
                    var maxLigne = 33;
                    this.classement.forEach((classementItem, indexClassement)=>{
                        if (classementItem!=null) {
                            if (typeof(classementItem.classement) == "undefined") 
                                classementItem.classement = indexClassement+1;
                            if (this.nbPartiesCalcule < classementItem.partieScore.length) {
                                
                                this.nbPartiesCalcule = classementItem.partieScore.length
                            }
                            if (compteur<maxLigne) {
                                if (typeof(this.classementPagination[indexPagination]) == "undefined") {
                                    this.classementPagination[indexPagination] = [];
                                }
                                classementItem.rang = indexClassement;
                                this.classementPagination[indexPagination].push(classementItem);
                                compteur++;
                            }
                            else {
                                classementItem.rang = indexClassement;
                                this.classementPagination[indexPagination].push(classementItem);
                                indexPagination++;
                                compteur=0;
                            }
                        }
                    })
                    
                }
                else {
                    firebase_api.api.getDb().collection("club").doc(this.club.id)
                        .collection("tournois").doc(this.tournoi.id).collection("parties").get().then(parties=>{
                       
                        var nbParties = parties.docs.length;
                        var partiesConstruct = [nbParties];
                        var indicePartieCurrent = 0;
                        parties.docs.forEach((partie, indicePartie)=>{
                           
                            var partieData = partie.data();
                            
                            this.finish = (partieData.state == "FINISH") && this.finish;
                            var partieItem = {
                                equipes: []
                            }
                             
                            partie.ref.collection("equipes").get().then(equipesDoc=>{
                                
                                equipesDoc.docs.forEach((equipe, indiceEquipe)=>{

                                    partieItem.equipes.push(equipe.data());
                                    if ((indiceEquipe == equipesDoc.docs.length - 1)){
                                        partiesConstruct[indicePartie]=partieItem;    
                                        indicePartieCurrent++;
                                    }
                                  
                                    if (indicePartieCurrent == nbParties) {
                                   
                                        if (indiceEquipe == equipesDoc.docs.length - 1) {
                                          
                                            var partiesL = partiesConstruct.slice();
                                        
                                           
                                            this.classement = tournoi_fct.object.resultatTournoi(partiesConstruct, this.tournoi);
                                           
                                            this.classement.sort((a,b)=> {
                                                return b.score - a.score || b.diff - a.diff;
                                            });
                                            var classementModif = 1;
                                            var classementEgalite = true;
                                            this.classement.forEach((classementItem, indexClassement)=>{
                                                if (!classementEgalite)
                                                    classementModif = indexClassement+1;
                                                this.classement[indexClassement].classement = classementModif;
                                                if (indexClassement < this.classement.length-1) {
                                                    var currentItem = this.classement[indexClassement];
                                                    var currentItemNext = this.classement[indexClassement+1];
                                                    if (typeof(currentItemNext)!="undefined") {
                                                        if (currentItem.score != currentItemNext.score) {
                                                            classementModif ++;
                                                            classementEgalite = false;
                                                        }
                                                            
                                                        else if (currentItem.diff != currentItemNext.diff) {
                                                            classementModif ++;  
                                                            classementEgalite = false;    
                                                        }
                                                        else
                                                            classementEgalite = true;
                                                    }
                                                    else
                                                         classementEgalite = true;
                                                }
                                                
                                            })
                                        }


                                        this.parties = partiesConstruct;
                                    }
                                        
                                    
                                })
                                if (equipesDoc.docs.length==0) {
                                    if (indicePartie == parties.docs.length - 1) {
                                            this.classement = tournoi_fct.object.resultatTournoi(this.parties, this.tournoi);
                                            this.classement.sort((a,b)=> {
                                                return b.DIFF - a.score || b.diff - a.diff;
                                            });
                                    }
                                }
                            })
                            
                        })
                        
                        
                    })
                }
        }
        }    
        ,
        
    },
    computed: {
        showMenu: {
            get() {
                if (typeof(this.menu)=="undefined")
                    return true;
                else
                    return false;
            }
            
        },
        nbParties: {
            get() {
                if (this.tournoi) {
                    
                    if (this.tournoi.state=='FINISH')
                        return this.nbPartiesCalcule;
                    else {
                        return this.parties.length
                    }
                }
                else
                    return 0;      
            }
        },
         tabScore: {
            get() {
                var tab=[];
                for (var i=0;i<=this.maxPoint;i++)
                    tab.push(i+'');
                return tab;
            }
        },
    },
    mounted() {
       this.refresh();
    }
}
</script>